import Button from "../../../ui/Button/Button";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { updateUserInfo } from "../../../db/users";
import { validateEmail } from "../../../util/email";
import Input from "../../../ui/Input/Input";
import Container from "../../../ui/Container/Container";
import "./ConfirmDoctor.css";

function ConfirmDoctor({ doctor, onConfirmDoctorData }) {
  const authCtx = useContext(AuthContext);
  useEffect(() => {
    setEnteredFirstName(doctor.name);
    setEnteredLastName(doctor.lastName);
    setEnteredSurName(doctor.surName);
    setEnteredCardId(doctor.cardId);
    setEnteredSpeciality(doctor.speciality);
    setEnteredEmail(doctor.email);
    setEnteredOfficePhone(doctor.officePhone);
    setEnteredCelPhone(doctor.cellPhone);
  }, [doctor]);

  const [enteredFirstName, setEnteredFirstName] = useState("");
  const [enteredLastName, setEnteredLastName] = useState("");
  const [enteredSurName, setEnteredSurName] = useState("");
  const [enteredCardId, setEnteredCardId] = useState("");
  const [enteredSpeciality, setEnteredSpeciality] = useState("");
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredOfficePhone, setEnteredOfficePhone] = useState("");
  const [enteredCellPhone, setEnteredCelPhone] = useState("");

  const [dataInvalid, setDataInvalid] = useState({
    firstName: false,
    lastName: false,
    surName: false,
    cardId: false,
    email: false,
    cellPhone: false,
  });

  const [isUpdating, setIsUpdating] = useState(false);

  function updateInputValueHandler(inputType, e) {
    const enteredValue = e.target.value;
    switch (inputType) {
      case "firstName":
        setEnteredFirstName(enteredValue);
        break;
      case "lastName":
        setEnteredLastName(enteredValue);
        break;
      case "surName":
        setEnteredSurName(enteredValue);
        break;
      case "cardId":
        setEnteredCardId(enteredValue);
        break;
      case "speciality":
        setEnteredSpeciality(enteredValue);
        break;
      case "email":
        setEnteredEmail(enteredValue);
        break;
      case "officePhone":
        setEnteredOfficePhone(enteredValue);
        break;
      case "cellPhone":
        setEnteredCelPhone(enteredValue);
        break;
      default:
        break;
    }
  }

  async function confirmDoctorDataHandler() {
    if (validateConfirmedData()) {
      setIsUpdating(true);
      await updateDoctor();
      setIsUpdating(false);
    }
  }

  async function updateDoctor() {
    try {
      const userInfo = {
        name: enteredFirstName,
        lastName: enteredLastName,
        surName: enteredSurName,
        speciality: enteredSpeciality,
        cardId: enteredCardId,
        email: enteredEmail,
        officePhone: enteredOfficePhone,
        cellPhone: enteredCellPhone,
        doctorConfirmedData: true,
      };
      await updateUserInfo(authCtx.userId, userInfo, authCtx.token);
      onConfirmDoctorData(
        userInfo.name,
        userInfo.lastName,
        userInfo.surName,
        userInfo.cardId,
        userInfo.speciality
      );
      alert("Datos confirmados con éxito.");
    } catch (error) {
      alert("No se ha podido completar la confirmación, revisa tus datos.");
      setIsUpdating(false);
    }
  }

  function validateConfirmedData() {
    const firstNameIsValid = enteredFirstName.trim().length > 0;
    const lastNameIsValid = enteredLastName.trim().length > 0;
    const surNameIsValid = enteredSurName.trim().length > 0;
    const cardIdIsValid = enteredCardId.trim().length > 4;
    const emailIsValid = validateEmail(enteredEmail.trim());
    const cellPhoneIsValid = enteredCellPhone.trim().length === 10;

    if (
      !firstNameIsValid ||
      !lastNameIsValid ||
      !surNameIsValid ||
      !emailIsValid ||
      !cardIdIsValid ||
      !cellPhoneIsValid
    ) {
      alert("Revisa los datos que ingresaste.");
      setDataInvalid({
        firstName: !enteredFirstName.length,
        lastName: !enteredLastName.length,
        surName: !enteredSurName.length,
        email: !validateEmail(enteredEmail),
        cardId: !(enteredCardId.length > 4),
        cellPhone: !(enteredCellPhone.length === 10),
      });
      return false;
    }
    return true;
  }

  if (isUpdating) {
    return (
      <div>
        <p>"Confirmando datos del doctor..."</p>
      </div>
    );
  }

  return (
    <Container title="Confirmar datos">
      <div className="form">
        <Input
          label="Nombre"
          onUpdateValue={updateInputValueHandler.bind(this, "firstName")}
          value={enteredFirstName}
          isInvalid={dataInvalid.firstName}
          autoCompleteType="off"
        />
        <Input
          label="Apellido"
          onUpdateValue={updateInputValueHandler.bind(this, "lastName")}
          value={enteredLastName}
          isInvalid={dataInvalid.lastName}
          autoCompleteType="off"
        />
        <Input
          label="Segundo Apellido"
          onUpdateValue={updateInputValueHandler.bind(this, "surName")}
          value={enteredSurName}
          isInvalid={dataInvalid.surName}
          autoCompleteType="off"
        />
        <Input
          label="Especialidad (opcional)"
          onUpdateValue={updateInputValueHandler.bind(this, "speciality")}
          value={enteredSpeciality}
          autoCompleteType="off"
        />
        <Input
          label="Cedula Profesional"
          onUpdateValue={updateInputValueHandler.bind(this, "cardId")}
          value={enteredCardId}
          keyboardType="number-pad"
          isInvalid={dataInvalid.cardId}
          autoCompleteType="off"
        />
        <Input
          label="Correo Electrónico"
          onUpdateValue={updateInputValueHandler.bind(this, "email")}
          value={enteredEmail}
          keyboardType="email-address"
          isInvalid={dataInvalid.email}
          autoCompleteType="off"
        />
        <Input
          label="Teléfono de oficina (opcional)"
          onUpdateValue={updateInputValueHandler.bind(this, "officePhone")}
          value={enteredOfficePhone}
          keyboardType="phone-pad"
          autoCompleteType="off"
        />
        <Input
          label="Teléfono celular (10 dígitos)"
          onUpdateValue={updateInputValueHandler.bind(this, "cellPhone")}
          value={enteredCellPhone}
          keyboardType="phone-pad"
          isInvalid={dataInvalid.cellPhone}
          autoCompleteType="off"
        />
        <div className="buttons">
          <Button onPress={confirmDoctorDataHandler}>Confirmo datos</Button>
        </div>
      </div>
    </Container>
  );
}

export default ConfirmDoctor;
